import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientInformationForm() {
    return (
        <PatientFormTemplate formTitle="Your Information" />
    );
}